import { NavigationAwareObject } from '../NavigationAwareObject';
import { RenderObject } from '../RenderObject';
import { vec3 } from 'gl-matrix';
import { NavigationBehaviourBase } from './NavigationBehaviour';

export class EntityMovementBehaviour extends NavigationBehaviourBase {
  private _running = false;
  private navObject?: NavigationAwareObject;
  private baseSpeed = 0;

  constructor(public entity: RenderObject) {
    super();
  }

  public get running(): boolean {
    return this._running;
  }

  public set running(value: boolean) {
    this._running = value;
    if (this.navObject) {
      this.navObject.movement.speed = value ? this.baseSpeed * 2 : this.baseSpeed;
    }
  }

  attach(navObject: NavigationAwareObject) {
    this.navObject = navObject;
    this.baseSpeed = navObject.movement.speed;

    navObject.movement.onStep.subscribe((step) => {
      let dir = vec3.subtract(vec3.create(), step.newPosition, step.oldPosition);
      this.entity.rotateTo(dir);
      this.setMoveAnimation(this.entity, this._running ? 'Run' : 'Walk');
    });

    navObject.movement.onComplete.subscribe((mv) => {
      this.setMoveAnimation(this.entity, 'Idle');
    });
  }

  detach(navObject: NavigationAwareObject) {}
}
